import React from 'react'
import PropTypes from 'prop-types'
import * as Uppy from '@uppy/core'
import { DashboardModal } from '@uppy/react'
import Tus from '@uppy/tus'
import AwsS3 from '@uppy/aws-s3'
import AwsS3Multipart from '@uppy/aws-s3-multipart'
import GoogleDrive from '@uppy/google-drive'
import '../assets/styles/uppy.css'
import { DEBUG } from '../config/constants'

const uppy = Uppy({
  id: 'uppy',
  autoProceed: DEBUG,
  debug: true,
  restrictions: {
    maxFileSize: false,
    maxNumberOfFiles: false,
    minNumberOfFiles: false,
    allowedFileTypes: false
  }
})
      // .use(Tus, { endpoint: 'http://ec2-34-208-116-16.us-west-2.compute.amazonaws.com:1080/' })
      .use(Tus, { endpoint: 'http://upload.looknorthservices.com:1080/files/' })
      // .use(GoogleDrive, { host: 'https://server.uppy.io' })
      // .use(AwsS3Multipart, { limit: 4, serverUrl: 'https://g984pgvmd0.execute-api.us-east-1.amazonaws.com/dev' })
      // .use(Tus, { endpoint: 'https://master.tus.io/files/' })
      // .use(GoogleDrive, { host: 'https://server.uppy.io' })
  // .use(Tus, { endpoint: DEBUG ? 'http://172.17.0.2:1080/files/' : 'https://master.tus.io/files/' })
  .run()

const UploadModal = props => {
  // const {
  //   ...rest
  // } = props
  // console.log({...rest})
  // return (
  //   <DashboardModal {...rest} />
  // )

  return (
    <DashboardModal
      open={props.open}
      uppy={props.uppy}
      onRequestClose={props.onRequestClose}
      closeModalOnClickOutside={true}
      />
  )
}

UploadModal.propTypes = {
  onComplete: PropTypes.func,
  onRequestClose: PropTypes.func,
  open: PropTypes.bool,
  // note: PropTypes.str,
  showProgressDetails: PropTypes.bool,
  uppy: PropTypes.object
}

UploadModal.defaultProps = {
  onComplete: result => console.log('result', result),
  onRequestClose: () => console.log('onRequestClose'),
  // note: 'Upload a geojson file',
  // open: true,
  showProgressDetails: true,
  plugins: ['GoogleDrive'],
  uppy: uppy,
  closeModalOnClickOutside: true
}

export default UploadModal



// WEBPACK FOOTER //
// ./src/upload/UploadModal.js